import type {SharedBulkActionsItemPickerProps} from '@github-ui/item-picker-base/ItemPicker'
import type {LabelPickerBaseProps, LabelPickerLabel as LabelPickerBaseLabel} from '@github-ui/item-picker-label'

import {BulkIssuesItemPickerLabelTsqWithRelayWrapper} from './BulkIssuesItemPickerLabelTsqWithRelayWrapper'
import {LabelPickerTsqWithRelayWrapper} from './LabelPickerTsqWithRelayWrapper'

export type LabelPickerLabel = LabelPickerBaseLabel

export type LabelPickerProps = Omit<LabelPickerBaseProps, 'filterItems'> & {
  labelNames?: string[]
}

export type BulkItemPickerLabelProps = Omit<LabelPickerProps, 'onSelectionChange' | 'filterItems' | 'labels'> & {
  existingIssueLabels: Map<string, string[]>
  labelAppliedToAll: LabelPickerLabel[]
  connectionIds: {[key: string]: string[]}
} & SharedBulkActionsItemPickerProps

export function BulkIssuesItemPickerLabel(props: BulkItemPickerLabelProps) {
  return <BulkIssuesItemPickerLabelTsqWithRelayWrapper {...props} />
}

export function LabelPicker(props: LabelPickerProps) {
  return <LabelPickerTsqWithRelayWrapper {...props} />
}

try{ BulkIssuesItemPickerLabel.displayName ||= 'BulkIssuesItemPickerLabel' } catch {}
try{ LabelPicker.displayName ||= 'LabelPicker' } catch {}